import { EChatbotActionTypes, TToggleChatbotPeriodicityMenu } from './types';
import {
  EChatbotPeriodicity,
  IChatbotMessageInfoBlockSchema,
  IChatbotActionButtonSchema,
  IChatbotOnboardingButtonSchema,
} from '../../types/chatbot';
import { TChatbotMenuState } from '../../types/chatbotMenu';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export const setChatbotRowVersion = actionGenerator<EChatbotActionTypes.SetChatbotRowVersion, number>(
  EChatbotActionTypes.SetChatbotRowVersion,
);

export const setChatbotUnreadMessagesCount = actionGenerator<EChatbotActionTypes.SetChatbotUnreadMessagesCount, number>(
  EChatbotActionTypes.SetChatbotUnreadMessagesCount,
);
export const setChatbotPollingIntervalId = actionGenerator<
  EChatbotActionTypes.SetChatbotPollingIntervalId,
  number | null
>(EChatbotActionTypes.SetChatbotPollingIntervalId);

export const setChatbotPeriodicity = actionGenerator<EChatbotActionTypes.SetChatbotPeriodicity, EChatbotPeriodicity>(
  EChatbotActionTypes.SetChatbotPeriodicity,
);

export const toggleChatbotPeriodicityMenu: (value?: boolean) => TToggleChatbotPeriodicityMenu = actionGenerator<
  EChatbotActionTypes.ToggleChatbotPeriodicityMenu,
  boolean
>(EChatbotActionTypes.ToggleChatbotPeriodicityMenu);

export const setChatbotHasPollAnswers = actionGenerator<EChatbotActionTypes.SetChatbotHasPollAnswers, boolean>(
  EChatbotActionTypes.SetChatbotHasPollAnswers,
);

export const setChatbotMenuText = actionGenerator<EChatbotActionTypes.SetChatbotMenuText, string>(
  EChatbotActionTypes.SetChatbotMenuText,
);

export const setChatbotMessageInfoBlock = actionGenerator<
  EChatbotActionTypes.SetChatbotMessageInfoBlock,
  IChatbotMessageInfoBlockSchema | undefined
>(EChatbotActionTypes.SetChatbotMessageInfoBlock);

export const setChatbotActionButtons = actionGenerator<
  EChatbotActionTypes.SetChatbotActionButtons,
  IChatbotActionButtonSchema[]
>(EChatbotActionTypes.SetChatbotActionButtons);

export const setChatbotOnboardingButtons = actionGenerator<
  EChatbotActionTypes.SetChatbotOnboardingButtons,
  IChatbotOnboardingButtonSchema[]
>(EChatbotActionTypes.SetChatbotOnboardingButtons);

export const setChatbotMenuActionButtons = actionGenerator<
  EChatbotActionTypes.SetChatbotMenuActionButtons,
  IChatbotActionButtonSchema[]
>(EChatbotActionTypes.SetChatbotMenuActionButtons);

export const setChatbotIsTyping = actionGenerator<EChatbotActionTypes.SetChatbotIsTyping, boolean>(
  EChatbotActionTypes.SetChatbotIsTyping,
);

export const setChatbotMessageSending = actionGenerator<EChatbotActionTypes.SetChatbotMessageSending, boolean>(
  EChatbotActionTypes.SetChatbotMessageSending,
);

export const setChatbotIsOpenEventSent = actionGenerator<EChatbotActionTypes.SetChatbotIsOpenEventSent, boolean>(
  EChatbotActionTypes.SetChatbotIsOpenEventSent,
);

export const setChatbotMenu = actionGenerator<EChatbotActionTypes.SetChatbotMenu, TChatbotMenuState>(
  EChatbotActionTypes.SetChatbotMenu,
);
